export const PATHS = Object.freeze({
  REFUELING: '/refueling',
  PARKING: '/parking',
  ON_STREET_PARKING: '/on-street-parking',
  AUTO_DETAILING: '/auto-detailing',
  PROMOTION: '/promotion',
  PROMOTION_DETAIL: '/promotion-detail/:id',
  PROMOTION_GROUP: '/promotion-group/:id',
  GAS_STATIONS: '/gas-stations',
  GAS_STATIONS_POI_COLLECTIONS: '/gas-stations/poi_collections',
  PARKINGLOTS: '/parkinglots',
  PARKINGLOTS_POI_COLLECTIONS: '/parkinglots/poi_collections',
  CAR_BEAUTY_STORES: '/car-beauty-stores',
  CAR_BEAUTY_STORES_POI_COLLECTIONS: '/car-beauty-stores/poi_collections',
  AUTO_REPAIR_STORES: '/auto-repair-stores',
  AUTO_REPAIR_STORES_POI_COLLECTIONS: '/auto-repair-stores/poi_collections',
  CAR_WASH_STORES: '/car-wash-stores',
  CAR_WASH_STORES_POI_COLLECTIONS: '/car-wash-stores/poi_collections',
  CHARGING_STORES: '/charging-stores',
  CHARGING_STORES_POI_COLLECTIONS: '/charging-stores/poi_collections',
  USER: '/user',
  REDIRECT: '/redirect',
  CAR_BEAUTY: '/car-beauty',
  GAS_PRICE: '/gas-price',
  APP_SERVICES: '/app-services',
});

export const DISTRIBUTOR = Object.freeze({
  AUTOPASS: 'AUTOPASS',
  CATHAYMR: 'CATHAYMR',
  CPCPAY: 'CPCPAY',
  LINE_BANK: 'LINE_BANK',
  IKNOW99: 'IKNOW99',
  AUTO_PARTNER: 'AUTO_PARTNER',
  NPCPAY: 'NPCPAY',
  MYTOYOTA: 'MYTOYOTA',
  LEXUS_PLUS: 'LEXUS_PLUS',
  WAFFLE: 'WAFFLE',
  NONE: 'NONE',
});

export const PROMOTION_CATAG = Object.freeze({
  REFUELING: {
    type: 'RefuelingPromotion',
    id: 'refueling-promotion',
  },
  PARKING: {
    type: 'ParkingPromotion',
    id: 'parking-promotion',
  },
  ON_STREET_PARKING: {
    type: 'OnStreetParkingPromotion',
    id: 'on-street-parking-promotion',
  },
  AUTO_DETAILING: {
    type: 'InvoicePromotion',
    id: 'auto-detailing-promotion',
  },
  FAKE: {
    type: 'FakePromotion',
    id: 'fake-promotion',
  },
});

/**
 * @returns { 'CPCPAY' | 'CATHAYMR' | 'LINE_BANK' | 'AUTOPASS' | 'NONE'}
 */
export const distributor = () => {
  switch (process.env.REACT_APP_DISTRIBUTOR) {
    case 'AUTOPASS':
      return DISTRIBUTOR.AUTOPASS;
    case 'CATHAYMR':
      return DISTRIBUTOR.CATHAYMR;
    case 'CPCPAY':
      return DISTRIBUTOR.CPCPAY;
    case 'LINE_BANK':
      return DISTRIBUTOR.LINE_BANK;
    case 'IKNOW99':
      return DISTRIBUTOR.IKNOW99;
    case 'AUTO_PARTNER':
      return DISTRIBUTOR.AUTO_PARTNER;
    case 'NPCPAY':
      return DISTRIBUTOR.NPCPAY;
    case 'MYTOYOTA':
      return DISTRIBUTOR.MYTOYOTA;
    case 'LEXUS_PLUS':
      return DISTRIBUTOR.LEXUS_PLUS;
    case 'WAFFLE':
      return DISTRIBUTOR.WAFFLE;
    default:
      return DISTRIBUTOR.NONE;
  }
};

export const distributorName = dist => {
  switch (dist) {
    case 'AUTOPASS':
      return '車麻吉';
    case 'CATHAYMR':
      return '國泰優惠';
    case 'WAFFLE':
      return '窩福';
    case 'CPCPAY':
      return '中油Pay';
    case 'LINE_BANK':
      return 'Line Bank';
    case 'MYTOYOTA':
      return 'My Toyota';
    case 'LEXUS_PLUS':
      return 'Lexus Plus';
    case 'IKNOW99':
      return 'iKnow99';
    case 'AUTO_PARTNER':
      return 'AutoPartner';
    case 'NPCPAY':
      return '全國';
    default:
      return '車麻吉';
  }
};

export const distributorNameEn = () => {
  switch (distributor()) {
    case 'AUTOPASS':
      return 'AUTOPASS';
    case 'CATHAYMR':
      return 'CATHAYMR';
    case 'CPCPAY':
      return 'CPCPAY';
    case 'LINE_BANK':
      return 'LINE BANK';
    case 'IKNOW99':
      return 'IKNOW99';
    case 'AUTO_PARTNER':
      return 'AUTO PARTNER';
    case 'MYTOYOTA':
      return 'MY TOYOTA';
    case 'LEXUS_PLUS':
      return 'LEXUS PLUS';
    case 'NPCPAY':
      return 'NPC PAY';
    case 'NONE':
      return 'MOCHIPAY';
    default:
      return 'MOCHIPAY';
  }
};

export const isMochipay = distributor() === DISTRIBUTOR.NONE;
export const isAutopass = distributor() === DISTRIBUTOR.AUTOPASS;
export const isCathayMr = distributor() === DISTRIBUTOR.CATHAYMR;
export const isCpcpay = distributor() === DISTRIBUTOR.CPCPAY;
export const isLineBank = distributor() === DISTRIBUTOR.LINE_BANK;
export const isIknow99 = distributor() === DISTRIBUTOR.IKNOW99;
export const isAutoPartner = distributor() === DISTRIBUTOR.AUTO_PARTNER;
export const isNpcpay = distributor() === DISTRIBUTOR.NPCPAY;

export const isMochiService = distributor() === DISTRIBUTOR.AUTOPASS || distributor() === DISTRIBUTOR.NONE;
export const noScanPayService = isCpcpay || isIknow99 || isLineBank || isNpcpay;

export const MEMBER_ITEM = Object.freeze({
  PROFILE: 'profile',
  PAYMENT: 'payment',
  LICENSE_PLATES: 'license-plates',
  ORDERS: 'orders',
  RECEIPT: 'receipt',
});

export const memberItemName = item => {
  switch (item) {
    case 'profile':
      return '個人資訊';
    case 'payment':
      return '付款方式';
    case 'license-plates':
      return '付款車牌';
    case 'orders':
      return '消費記錄';
    case 'receipt':
      return '發票資訊';
    default:
      return '';
  }
};

const deployEnv = () => {
  if (process.env.REACT_APP_DEPLOY_ENV === 'prod') {
    return 'prod';
  } else {
    return 'alpha';
  }
};

export const isAlpha = deployEnv() === 'alpha';
// export const isAlpha = false;

const ALPHA_API_URL = 'https://api-alpha.pklotcorp.com';
const PROD_API_URL = 'https://api.autopass.xyz';
const ALPHA_MOCHIPAY_API_URL = 'https://user-api-alpha-mochipay.pklotcorp.com/';
const PROD_MOCHIPAY_API_URL = 'https://user-api.mochipay.xyz/';
const ALPHA_MOTO_PROMOTION_URL = 'https://event-alpha.pklotcorp.com/motor-on-street-parking';
const MOTO_PROMOTION_URL = 'https://event.autopass.xyz/motor-on-street-parking';
const ALPHA_TAIPEI_CITY_PARKING_COLLECTION_ID = '4d37285b-5232-49ec-a2a3-1f45d3e87def';
const PROD_TAIPEI_CITY_PARKING_COLLECTION_ID = '3d80025c-0a7b-4bcb-863c-8365bc6d7069';
const ALPHA_TERMS_URL = 'https://jupiter-alpha.pklotcorp.com/terms';
const PROD_TERMS_URL = 'https://autopass.xyz/terms';
const ALPHA_PRIVACY_URL = 'https://jupiter-alpha.pklotcorp.com/privacy';
const PROD_PRIVACY_URL = 'https://autopass.xyz/privacy';
const ALPHA_MEDIA_CENTER = 'https://newsroom-alpha.pklotcorp.com';
const PROD_MEDIA_CENTER = 'https://newsroom.autopass.xyz';
const ALPHA_AUTOPASS_URL = 'https://alpha.pklotcorp.com/';
const PROD_AUTOPASS_URL = 'https://autopass.xyz/';
const ALPHA_MOCHI_CLIENT_WEB_URL = 'https://mochi-client-alpha-mochipay.pklotcorp.com';
const PROD_MOCHI_CLIENT_WEB_URL = 'https://mochi-client.mochipay.xyz';
const ALPHA_MOCHI_MAP_URL = 'https://maps-alpha.pklotcorp.com';
const PROD_MOCHI_MAP_URL = 'https://maps.autopass.xyz';
const ALPHA_CONTACT_FORM_URL = 'https://contact-alpha.pklotcorp.com';
const PROD_CONTACT_FORM_URL = 'https://contact.autopass.xyz';
const ALPHA_MAINTENANCE_CONFIG_URL = 'https://maintenance-alpha.pklotcorp.com/config.json';
const PROD_MAINTENANCE_CONFIG_URL = 'https://maintenance.autopass.xyz/config.json';
const ALPHA_ENTERPRISE_URL = 'https://enterprise-alpha-mochipay.pklotcorp.com';
const PROD_ENTERPRISE_URL = 'https://enterprise.autopass.xyz';

const ALPHA_AUTOPASS_CLIENT_UID = '8b19e1c872facc0333a62cb94691240cd885e82661c823d92b24b639e7bff1aa';
const PROD_AUTOPASS_CLIENT_UID = '97cae66ea75dc00c66c289ad9296f42911caec3f2d8c328b62e3350ec0699188';
const ALPHA_CATHAYMR_CLIENT_UID = 'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60';
const PROD_CATHAYMR_CLIENT_UID = '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247';
const ALPHA_CPCPAY_CLIENT_UID = 'bcff0c33c2dc6a79babb27e4809d7429d17a7758d35f861c42ddf36e6c10b00c';
const PROD_CPCPAY_CLIENT_UID = 'faaa5a2d6cbe1ce16b6830efac52c128d202309a07309a7afdef023c058361fe';
const ALPHA_LINEBANK_CLIENT_UID = 'BFLA0qfahaAJlC1SxJpu5EtUvc8wSCXDmDR3hmlOn3Y';
const PROD_LINEBANK_CLIENT_UID = '2ecAMkCFnu50162eHJTwTRgzd3QwhrgsqMj14zQ0mnc';
const ALPHA_IKNOW99_CLIENT_UID = '7dJqyHNieVRJ7sFofvEElAi1X7Tj5DAF_MCe3s6S7cc';
const PROD_IKNOW99_CLIENT_UID = 'PDNMGnwiHpH0vonZuJQCYU8WaZRd8B4SdbCfMr5jNdA';
const ALPHA_AUTO_PARTNER_CLIENT_UID = 'OO_IGjM0NFAfKH2UC6nL2f-StRFcjDvFtcTnGiDyEbc';
const PROD_AUTO_PARTNER_CLIENT_UID = 'EP6DskS5UXZ4lgFmIQcHu7NGpyzbwzLvr8VAIqqXecE';
const ALPHA_NPC_CLIENT_UID = '77_fkgtIBKNsPqRM5Eo-UEkNv5aNZmMnDFayNLtB1dE';
const PROD_NPC_CLIENT_UID = 'vXqMc68EGmKxu_UoGRdGlb4cJRbQY1pohY_5VrODBpo';
const ALPHA_MOCHIPAY_CLIENT_UID = '307e7e9c9434047529e5d7374c60ba4ca5e59ae31e4cb3973e0f12e096112ab6';
const PROD_MOCHIPAY_CLIENT_UID = 'd3e444edf38a3bdc85834c61e03ab6480e2844c3ed4bc227f8775dad1bd862e4';
const ALPHA_MYTOYOTA_CLIENT_UID = 'cc8AlN5_R8xq5MvgPRk6tubiCksGru0rJt67Dule_Vg';
const PROD_MYTOYOTA_CLIENT_UID = 'VkUcr1kGJeLmzZ6TULCmM_Vzza8cffJHyf2VyrQ12SY';
const ALPHA_LEXUS_PLUS_CLIENT_UID = 'JS_oZWbm5VnjqTGEfp4d5jHUf7KHjYjR9-yP9vs7nUk';
const PROD_LEXUS_PLUS_CLIENT_UID = '0DWXqmwqKMlfB5VUUiwI9aAnEdJaH8lqfrzJPlgntCA';
const ALPHA_WAFFLE_CLIENT_UID = '7gRZJcSIM58Bet8f3c8nllWGGl2mzBQvOPmfu7Phtrc';
const PROD_WAFFLE_CLIENT_UID = 'pAgDM-uZGUMYHonqXhOyqSWwMkMdlf7lDklh8i2cj6I';

const deepLinkScheme = isAlpha ? 'autopassapp-alpha://' : 'autopassapp://';
export const inCooperationParkinglotDeepLink = `${deepLinkScheme}open_collection?poi_collection=parkinglot_all`;
export const inCooperationGasStationDeepLink = `${deepLinkScheme}open_collection?poi_collection=gas_station_all`;
export const mochipassGasStationDeepLink = `${deepLinkScheme}open_collection?poi_collection=pass_service`;
export const mochipayGasStationDeepLink = `${deepLinkScheme}open_collection?poi_collection=gas_station_mochipay`;
export const openCooperationGasStationCard = id => `${deepLinkScheme}open_gas_station_card?id=${id}&expanded=true`;
export const openCooperationParkinglotCard = id => `${deepLinkScheme}open_parkinglot_card?id=${id}&expanded=true`;

export const clientUid = () => {
  switch (distributor()) {
    case 'AUTOPASS':
      return isAlpha ? ALPHA_AUTOPASS_CLIENT_UID : PROD_AUTOPASS_CLIENT_UID;
    case 'CATHAYMR':
      return isAlpha ? ALPHA_CATHAYMR_CLIENT_UID : PROD_CATHAYMR_CLIENT_UID;
    case 'CPCPAY':
      return isAlpha ? ALPHA_CPCPAY_CLIENT_UID : PROD_CPCPAY_CLIENT_UID;
    case 'LINE_BANK':
      return isAlpha ? ALPHA_LINEBANK_CLIENT_UID : PROD_LINEBANK_CLIENT_UID;
    case 'IKNOW99':
      return isAlpha ? ALPHA_IKNOW99_CLIENT_UID : PROD_IKNOW99_CLIENT_UID;
    case 'AUTO_PARTNER':
      return isAlpha ? ALPHA_AUTO_PARTNER_CLIENT_UID : PROD_AUTO_PARTNER_CLIENT_UID;
    case 'NPCPAY':
      return isAlpha ? ALPHA_NPC_CLIENT_UID : PROD_NPC_CLIENT_UID;
    case 'MYTOYOTA':
      return isAlpha ? ALPHA_MYTOYOTA_CLIENT_UID : PROD_MYTOYOTA_CLIENT_UID;
    case 'LEXUS_PLUS':
      return isAlpha ? ALPHA_LEXUS_PLUS_CLIENT_UID : PROD_LEXUS_PLUS_CLIENT_UID;
    case 'WAFFLE':
      return isAlpha ? ALPHA_WAFFLE_CLIENT_UID : PROD_WAFFLE_CLIENT_UID;
    default:
      return isAlpha ? ALPHA_MOCHIPAY_CLIENT_UID : PROD_MOCHIPAY_CLIENT_UID;
  }
};

export const apiUrl = () => {
  return isAlpha ? ALPHA_API_URL : PROD_API_URL;
};

export const mochipayApiUrl = () => {
  return isAlpha ? ALPHA_MOCHIPAY_API_URL : PROD_MOCHIPAY_API_URL;
};

export const motoPromotionUrl = () => {
  return isAlpha ? ALPHA_MOTO_PROMOTION_URL : MOTO_PROMOTION_URL;
};

export const taipeiCityParkingCollectionId = () => {
  return isAlpha ? ALPHA_TAIPEI_CITY_PARKING_COLLECTION_ID : PROD_TAIPEI_CITY_PARKING_COLLECTION_ID;
};

export const termsUrl = () => {
  return isAlpha ? ALPHA_TERMS_URL : PROD_TERMS_URL;
};

export const privacyUrl = () => {
  return isAlpha ? ALPHA_PRIVACY_URL : PROD_PRIVACY_URL;
};

export const mediaCenterUrl = () => {
  return isAlpha ? ALPHA_MEDIA_CENTER : PROD_MEDIA_CENTER;
};

export const autopassUrl = () => {
  return isAlpha ? ALPHA_AUTOPASS_URL : PROD_AUTOPASS_URL;
};

export const mochiClientWebUrl = () => {
  return isAlpha ? ALPHA_MOCHI_CLIENT_WEB_URL : PROD_MOCHI_CLIENT_WEB_URL;
};

export const mochiMapUrl = () => {
  return isAlpha ? ALPHA_MOCHI_MAP_URL : PROD_MOCHI_MAP_URL;
};

export const contactFormUrl = () => {
  return isAlpha ? ALPHA_CONTACT_FORM_URL : PROD_CONTACT_FORM_URL;
};

export const maintenanceConfigUrl = () => {
  return isAlpha ? ALPHA_MAINTENANCE_CONFIG_URL : PROD_MAINTENANCE_CONFIG_URL;
};

export const enterpriseUrl = () => {
  return isAlpha ? ALPHA_ENTERPRISE_URL : PROD_ENTERPRISE_URL;
};

const ALPHA_AMPLITUDE_TOKEN = '572d06dc0debd99d97e75053b551006e';
const PROD_AMPLITUDE_TOKEN = 'fedc49c4862fa63d4dfc37cf825c0d14';

const ALPHA_ANALYTICS_TOKEN = '4568fe9b8b11c57aebe5e40ac3d278d7';
const PROD_ANALYTICS_TOKEN = '65e01d33d3c2a819679dc7f59d09aa5d';

const ALPHA_BRANCH_KEY = 'key_test_klrTPRwqxvfNYduMkprH1lkdzDnue52B';
const PROD_BRANCH_KEY = 'key_live_cpsPJIAwyxmR0eyKceDPQdlfExdAbWZn';

export const amplitudeToken = isAlpha ? ALPHA_AMPLITUDE_TOKEN : PROD_AMPLITUDE_TOKEN;
export const analyticsToken = isAlpha ? ALPHA_ANALYTICS_TOKEN : PROD_ANALYTICS_TOKEN;
export const branchKey = isAlpha ? ALPHA_BRANCH_KEY : PROD_BRANCH_KEY;
const typeformUrl = isAlpha ? 'https://pklotcorp.com/mochi_pass' : 'https://autopass.xyz/mochi_pass';
const forbiddenTypeformUrl = 'https://pklotcorp.typeform.com/to/vcz58VQN';

export const refuelingPassLink = {
  [DISTRIBUTOR.AUTOPASS]: `${typeformUrl}?utm_source=mochiapp`,
  [DISTRIBUTOR.CATHAYMR]: `${forbiddenTypeformUrl}?utm_source=mrmochipay`,
  [DISTRIBUTOR.AUTO_PARTNER]: `${typeformUrl}?utm_source=AutoPartner`,
};

export const distributorRefuelingPassLink = refuelingPassLink[distributor()];

export const autopassDownloadLink = {
  ios: 'https://apps.apple.com/tw/app/%E8%BB%8A%E9%BA%BB%E5%90%89/id1332581201',
  android: 'https://play.google.com/store/apps/details?id=com.pklotcorp.autopass&hl=zh_TW&gl=US',
  desktop: 'https://autopass.xyz/',
};

export const cpcpayDownloadLink = {
  ios: 'https://apps.apple.com/tw/app/%E4%B8%AD%E6%B2%B9pay/id1475467410',
  android: 'https://play.google.com/store/apps/details?id=com.cpc.cpcpay&hl=zh_TW&gl=US',
  desktop: 'https://cpcpay.cpc.com.tw/CPCGateway/CampaignSrv/MGM/mgm.html?mgmCode=4dc1db53ed',
};

export const waffleDownloadLink = {
  ios:
    'https://apps.apple.com/tw/app/%E7%AA%A9%E7%A6%8F%E7%A4%BE%E5%8D%80-%E4%BD%8F%E6%88%B6%E5%B0%88%E7%94%A8/id1239750650',
  android: 'https://play.google.com/store/apps/details?id=city.waffle.user&hl=zh_TW&gl=US',
  desktop: 'https://www.waffle.city/',
};

export const iknow99DownloadLink = {
  ios: 'https://apps.apple.com/tw/app/%E6%84%9B%E8%BB%8A99/id1117724308',
  android: 'https://play.google.com/store/apps/details?id=com.iknow99&hl=zh_TW&gl=US',
  desktop: 'https://iknow99.com/?l=zh-HK',
};

export const linebankDownloadLink = {
  ios: 'https://apps.apple.com/tw/app/line-bank-taiwan/id1527512597',
  android: 'https://play.google.com/store/apps/details?id=com.linebank.tw&hl=zh_TW&gl=US',
  desktop: 'https://www.linebank.com.tw/',
};

export const myToyotaDownloadLink = {
  ios: 'https://itunes.apple.com/tw/app/qu-dong-cheng-shi/id595563830?l=zh&mt=8',
  android: 'https://play.google.com/store/apps/details?id=com.hotai.toyota.citydriver.official&hl=zh_TW',
  desktop: 'https://www.toyota.com.tw/app/mytoyota/',
};

export const npcpayDownloadLink = {
  ios: 'https://apps.apple.com/tw/app/%E5%85%A8%E5%9C%8B%E5%8A%A0%E6%B2%B9%E7%AB%99/id1426238552',
  android: 'https://play.google.com/store/apps/details?id=tw.com.npcgas.member&hl=zh_TW&gl=US',
  desktop: 'https://www.npcgas.com.tw/home/index',
};

export const lexusPlusDownloadLink = {
  ios: 'https://apps.apple.com/tw/app/lexus-plus/id626100497',
  android: 'https://play.google.com/store/apps/details?id=com.hotaimotor.lexusplus&hl=zh_TW&gl=US',
  desktop: 'https://www.lexus.com.tw/app/lexusplus/',
};

const devFakePromotionMap = {
  '7a8b37c0-642c-489a-8fed-5930118ba6dc': [
    {
      type: 'RefuelingPromotion',
      id: '1d31d1e5-cd73-43d4-a0ff-3f74e74fd31f',
    },
    {
      type: 'ParkingPromotion',
      id: 'b1855279-e2bc-4ec1-a74c-343c8505779d',
    },
  ],
  'd0be4134-d451-4c93-8f4a-79f760e5ae7f': [
    {
      type: 'ParkingPromotion',
      id: '5067bb40-63af-48ff-95d3-9c4b740d3452',
    },
  ],
  '18b02fea-a076-4e0e-9082-d6751914d088': [
    {
      type: 'RefuelingPromotion',
      id: 'eddc2f0f-ea1e-4880-9763-b1f50df0aa01',
    },
    {
      type: 'ParkingPromotion',
      id: '9bb77ed1-207d-4b44-acb5-6ba676e92002',
    },
  ],
  '9b2e3d7f-e047-46d4-b12f-83d7d01912d4': [
    {
      type: 'ParkingPromotion',
      id: '0939f002-e74c-4e42-adcf-b7d2929f5ecb',
    },
  ],
};

const prodFakePromotionMap = {
  '85f9bc73-60bb-45b0-b199-c9797c6b49cd': [
    {
      type: 'RefuelingPromotion',
      id: 'fbdfce07-5781-4d43-990c-0e27de5d26ab',
    },
    {
      type: 'ParkingPromotion',
      id: '9a465350-5e07-4eb5-a3b5-be6f3fff93b7',
    },
  ],
  '88d7faee-4d7f-4ffb-85d9-b6ce0c55be15': [
    {
      type: 'ParkingPromotion',
      id: 'ed0577d1-64ad-43c2-a42f-111765d2c8e9',
    },
  ],
  '295aefd6-0171-4920-ac8f-51d92e229d07': [
    {
      type: 'RefuelingPromotion',
      id: '757b6795-5733-4a31-ae12-6f3c71586a5b',
    },
  ],
};

export const fakePromotionMap = isAlpha ? devFakePromotionMap : prodFakePromotionMap;
